export function ADDRESSCODES(communityId) {
  return '/access/community/' + communityId + '/addresscodes/';
}
